import {MessageContentDataObject} from 'Pages/apps/default/projectPages/campaign/dataObjects';

export class MessageSourceDataObject extends MessageContentDataObject {
	/**
	 * @param {string|null} [id=null] - DB ID of the message content item.
	 * @param {CampaignMessageContentType|''} [messageType=''] - Message type (SMS, Viber, etc.).
	 * @param {string} [subject=''] - Subject of the message.
	 * @param {string} [body=''] - Message body text.
	 * @param {any} [bodySource] - Message body source.
	 * @param {?string} [image=null] - URL of the image that will be added below the message body.
	 * @param {boolean} [containsVideo=false] - Flag that specifies if the message body contains a video.
	 * @param {string} [video=''] - URL of the video that will be added below the message body.
	 * @param {string} [videoThumbnail=''] - URL of the video thumbnail that will be added below the message body.
	 * @param {?string} [link=null] - Link used for the button that will be added to the bottom of the message.
	 * @param {string} [linkText=''] - Label of the button that will be added to the bottom of the message.
	 * @param {?ViberCarouselItemDataObject[]} [carouselItems=null] - List of items that will be displayed in the
	 * carousel (Viber only). Null value is used to detect if the message is not a carousel. Message will be considered
	 * as a carousel if the value is an array even if it is empty.
	 * @param {Object} [customFields={}] - Custom fields specified by the user that will be sent to mobile app alongside
	 * the message. Custom fields are not visible in the message preview.
	 * @param {Object} [replacementFields={}] - Replacement fields specified by the user that will be used to replace
	 * placeholders in the message content template. Replacement field values are assigned using the open API.
	 * @param {?string} [templateId=null] - ID of the message content template. If templates are used, no other param
	 * (like a subject, body, etc.) will be used since they are defined by the template. This is currently used only for
	 * WhatsApp messages since templates are created by an external tool.
	 * @param {?string} [customFieldsJson=null] - Custom fields that will be added to the message.
	 */
	constructor(
		id = null, messageType = '', subject = '', body = '', bodySource, image = null, containsVideo = false, video = '',
		videoThumbnail = '', link = null, linkText = '', carouselItems = null, customFields = {}, replacementFields = {},
		templateId = null, customFieldsJson = null,
	) {
		super(
			id, messageType, subject, body, bodySource, image, containsVideo, video, videoThumbnail, link, linkText,
			carouselItems, customFields, replacementFields, templateId,
		);

		this.customFieldsJson = customFieldsJson;
	}
}